<div [ngClass]="{backdrop}">
  <div class="loader">
    @if (customLoadingTemplate) {
    <div class="file-progress-bar">
      <ng-container [ngTemplateOutlet]="customLoadingTemplate"></ng-container>
    </div>
    } @else {
    <div class="d-flex justify-content-center flex-column">
      @if(loadingMsg){
      <div class="mb-3">
        <span>{{ loadingMsg }}</span>
      </div>
      }
      <div>
        <div style="display: flex; gap: 0.5rem">
          @for (dot of dots; track $index) {
          <div class="dot" [ngStyle]="dotStyle"></div>
          }
        </div>
      </div>
    </div>
    }
  </div>
</div>
